import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, TextField, MenuItem, Button, Typography, Box, CircularProgress } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';

import TituloPagina from '../../components/layout/TituloPagina';
import Cartao from '../../components/templates/CardDash';
import { getDashboard } from '../../store/actions/dashboard';
import { getNegocio } from '../../store/actions/negocio';
import { moeda } from '../../assets/js/formatNumber';
import DialogAlert from '../../components/layout/DialogAlert';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} style={{ marginTop: '20px', marginBottom: '20px' }} />;
}

const Dashboard = props => {

    const { getDashboard, dash, negocioDoUsuario, negocio, getNegocio, loading } = props;

    const [filtroAno, setFiltroAno] = useState('');
    const [filtroMes, setFiltroMes] = useState('');
    const [toggleDialog, setToggleDialog] = useState(false);
    const [mensagemErro, setMensagemErro] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingMessage, setProcessingMessage] = useState('');

    const ano = [
        { label: '2026', value: '2026' },
    ];
    const mes = [
        { label: 'Janeiro', value: '1' },
        { label: 'Fevereiro', value: '2' },
        { label: 'Março', value: '3' },
        { label: 'Abril', value: '4' },
        { label: 'Maio', value: '5' },
        { label: 'Junho', value: '6' },
        { label: 'Julho', value: '7' },
        { label: 'Agosto', value: '8' },
        { label: 'Setembro', value: '9' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' },
    ]

    useEffect(() => {
        const hoje = new Date();
        const mesAtual = hoje.getMonth() + 1;
        const anoAtual = hoje.getFullYear();
        const values = { idNegocio: negocioDoUsuario, ano: anoAtual, mes: mesAtual };

        if (negocioDoUsuario && negocioDoUsuario > 0) {
            getDashboard(values);
            getNegocio(negocioDoUsuario);
        };
    }, [negocioDoUsuario]);

    function handleChange(event) {
        if (event.target.name === 'ano') {
            setFiltroAno(event.target.value);
            setFiltroMes('');
        }

        if (event.target.name === 'mes')
            setFiltroMes(event.target.value);

    }

    async function handleFiltrar() {
        if (filtroAno === '' || filtroMes === '') {
            setMensagemErro('Informe o ANO e o MÊS para filtrar.');
            setToggleDialog(true);
            return;
        }

        setProcessingMessage('Buscando informações...');
        setIsProcessing(true);

        const values = { idNegocio: negocioDoUsuario, ano: filtroAno, mes: filtroMes };
        await getDashboard(values);

        setIsProcessing(false);
        setProcessingMessage('');
    }

    function handleDialogError() {
        setToggleDialog(false);
        setMensagemErro('');
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Dashboard' subtitulo={new Date().toLocaleString('pt-BR')} />

            {dash !== null && Object.keys(dash).length > 0 ?
                <>
                    {
                        !negocio.stripePayoutsEnabled
                            ?
                            <Alert severity="warning">Atenção: A sua loja ainda não possui integração com a Stripe, nossa plataforma de pagamentos. Acesse o caminho a seguir e regularize: Gerenciar Negócio &gt; Integração Stripe.</Alert>
                            :
                            null
                    }
                    <Grid container spacing={2} style={{ alignItems: 'end' }}>
                        <Grid item xs={12} sm={12}>
                            <Box bgcolor="secondary.main" color="white" p={2}>
                                <Typography variant='h6' component='p'>
                                    Para Acompanhar
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='VENDAS AGUARDANDO PROVIDÊNCIA'
                                    valor={dash.quantidadeDeVendasAguardandoProvidencias}
                                    valorIdeal={0}
                                    onClick={() => window.location.href = '/vendas-em-andamento'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='DÚVIDAS SEM RESPOSTA'
                                    valor={dash.quantidadeDeDuvidasSemResposta}
                                    valorIdeal={0}
                                    onClick={() => window.location.href = '/perguntas-e-respostas'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='PRODUTOS SEM ESTOQUE'
                                    valor={dash.quantidadeDeProdutosComEstoqueZerado}
                                    valorIdeal={0}
                                    onClick={() => window.location.href = '/produtos'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='CATEGORIAS ATIVAS'
                                    valor={dash.quantidadeDeCategoriasAtivas}
                                    valorIdeal={1}
                                    onClick={() => window.location.href = '/categorias'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='PRODUTOS ATIVOS'
                                    valor={dash.quantidadeDeProdutosAtivos}
                                    valorIdeal={1}
                                    onClick={() => window.location.href = '/produtos'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='FUNCIONÁRIOS ATIVOS'
                                    valor={dash.quantidadeDeFuncionariosAtivos}
                                    onClick={() => window.location.href = '/funcionarios-da-loja'}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Box bgcolor="secondary.main" color="white" p={2}>
                                <Typography variant='h6' component='p'>
                                    Resultado do Mês
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                variant='outlined'
                                color='primary'
                                select
                                fullWidth
                                id="ano"
                                name="ano"
                                label="Ano"
                                value={filtroAno}
                                onChange={handleChange}
                            >
                                {ano.map((option) => (
                                    <MenuItem key={option.value} value={option.value} >{option.label}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                variant='outlined'
                                color='primary'
                                select
                                fullWidth
                                id="mes"
                                name="mes"
                                label="Mês"
                                value={filtroMes}
                                onChange={handleChange}
                            >
                                {mes.map((option) => (
                                    <MenuItem key={option.value} value={option.value} >{option.label}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={1} >
                            <Button color='secondary' variant='contained' onClick={handleFiltrar} >Selecionar</Button>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='VENDAS TOTAIS'
                                    valor={dash.quantidadeDeVendasNoMes}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='VENDAS FINALIZADAS'
                                    valor={dash.quantidadeDeVendasConcluidasNoMes}
                                    onClick={() => window.location.href = '/vendas-entregues'}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='VENDAS CANCELADAS'
                                    valor={dash.quantidadeDeVendasCanceladasNoMes}
                                    onClick={() => window.location.href = '/vendas-canceladas'}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='EM VENDAS TOTAIS'
                                    valor={moeda(dash.valorTotalDeVendasNoMes)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='EM VENDAS FINALIZADAS'
                                    valor={moeda(dash.valorTotalDeVendasConluidasNoMes)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Cartao
                                    titulo='DE VENDAS FINALIZADAS'
                                    valor={`${dash.percentualDeVendasConcluidasNoMes}%`}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </>
                :
                <Box sx={{ height: '70vh' }}>
                    <h3 style={{ textAlign: 'center' }}>Selecione um negócio no campo acima para continuar.</h3>
                </Box>
            }

            <DialogAlert
                title='Atenção'
                okButton={true}
                labelOkButton='Ok'
                okButtonClick={handleDialogError}
                openDialog={toggleDialog}>
                {mensagemErro}
            </DialogAlert>

            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={isProcessing}
                message={processingMessage}
            />
        </>
    )
}

const mapStateToProps = state => ({
    negocio: state.negocio.negocio,
    negocioDash: state.negocio.negocioDash,
    user: state.auth.user,
    dash: state.dashboard.dash,
    negocioDoUsuario: state.negocio.negocioDoUsuario,
    loading: state.dashboard.loading
});
const mapDispatchToProps = dispatch => bindActionCreators({
    getDashboard,
    getNegocio,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)